// extracted by mini-css-extract-plugin
module.exports = {"mobile-modal":"modal-wrapper_mobile-modal__t1g_9","desktop-modal":"modal-wrapper_desktop-modal__UnCRB"};